






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Course } from 'frontend/types';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';
import ModalCourseMap from 'frontend/views/courses/CoursePage/components/ModalCourseMap.vue';

@Component({
  components: {
    BriocheBackgroundImage,
    ModalCourseMap,
  },
})
export default class CourseModal extends Vue {
  @Prop({ type: Object, required: true })
  private course!: Course;

  mounted(): void {
    document.body.classList.add('no-scroll');
  }

  destroyed() {
    document.body.classList.remove('no-scroll');
  }

  private closeOverlay(): void {
    this.$emit('modal-closed');
  }
}
